import "./styles.scss";
import { useAppConstants } from "../../../../Hooks/useAppConstants";
import { EmailIconWhite } from "@/Utils/SVGExports/TitanWorkspace/EmailIconWhite";
import clsx from "clsx";

export function EmailOfferStrip({ mini = false, raw = false, extraLarge = false, customClasses = "", fontSize = "" }) {
  const {
    workspace: { sell_titan_email_free_with_domain, free_titan_licenses_count },
  } = useAppConstants();

  if (!sell_titan_email_free_with_domain) {
    return null;
  }

  const areMultipleAccounts = free_titan_licenses_count > 1;

  if (extraLarge) {
    return (
      <div
        className={
          `titan-strip-wrapper tw-z-10 tw-mb-[-16px] tw-mt-[20px] tw-flex tw-w-[100%] tw-flex-col tw-items-center tw-gap-[6px] tw-rounded-[4px] tw-p-[14px] tw-font-jakarta ` +
          customClasses
        }
      >
        <p className="tw-m-0 tw-text-[10px] tw-font-bold tw-tracking-[1.1px] tw-text-[#ffffff]">LIMITED TIME OFFER</p>
        <div className="tw-flex tw-items-center tw-gap-[8px]">
          <EmailIconWhite />
          <p className={"lh-solid tw-m-0 tw-text-[14px] tw-font-normal tw-text-[#ffffff]"}>
            <span className="tw-font-semibold">
              Get {free_titan_licenses_count} branded email account
              {areMultipleAccounts ? "s" : ""}
            </span>{" "}
            free with domain
          </p>
        </div>
      </div>
    );
  }

  const wrapperClass = !mini ? "tw-px-[12px] tw-py-[8px] tw-mb-[8px]" : "tw-px-[8.5px] tw-py-[5.5px] tw-ml-[3px]";
  const textSize = fontSize ? fontSize : !mini ? "tw-text-[14px]" : "tw-text-[11px]";
  const trailingSentence = 
    <>
      <span className="tw-font-bold">
        {" "}
        - Get {free_titan_licenses_count} branded matching email account{areMultipleAccounts ? "s" : ""}
      </span>{" "}
      free with every domain
    </>
  ;
  const resetClass = raw ? "tw-ml-[0px] " : "";

  return (
    <div
      className={
        `titan-strip-wrapper tw-z-10 tw-rounded-[2px] tw-font-jakarta ${wrapperClass} ${resetClass} ` + customClasses
      }
    >
      <p className={`tw-m-0 ${textSize} tw-bg-[transparent] tw-leading-[14px] tw-text-[#ffffff] `}>
        <span className={clsx("tw-font-bold ", mini ? "tw-tracking-[1px]" : "")}>LIMITED TIME OFFER</span>
        {!mini && trailingSentence}
      </p>
    </div>
  );
}
